import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-testid", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "w-4 h-4 mr-2",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = {
  key: 1,
  class: "w-4 h-4 ml-2",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      `${_ctx.classList} ${_ctx.theme} button`,
      _ctx.disabled ? 'cursor-not-allowed opacity-25' : '',
      _ctx.fullWidth ? 'w-full' : ' w-full sm:w-auto',
    ]),
    "data-testid": _ctx.testingId,
    disabled: _ctx.disabled,
    type: "button",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitClick && _ctx.emitClick(...args)))
  }, [
    (_ctx.isLeft)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("path", {
            d: "M15 19l-7-7 7-7",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.text) + " ", 1),
    (_ctx.isRight)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("path", {
            d: "M9 5l7 7-7 7",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
  ], 10, _hoisted_1))
}